
<empty-layout *ngIf="layout === 'empty'" [isLoading]="isLoading"></empty-layout>

<horizontal-layout *ngIf="layout === 'horizontal'" [isLoading]="isLoading"></horizontal-layout>


